import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { cloneDeep } from 'lodash-es';
import { Subscription } from 'rxjs';
import { RoleCode } from '../../../../../domain/consts';
import { DocumentStatus } from '../../../../../domain/dictionary.model';
import { EmailData } from '../../../../../domain/document.model';
import { ClauseType, Offer } from '../../../../../domain/offer.domain';
import { SummaryType } from '../../../../../domain/product.domain';
import { ScheduleFlag } from '../../../../../domain/schedule.model';
import { EntityRole, SystemUser } from '../../../../../domain/user.model';
import { DialogAction } from '../../../store/dialog.action';
import { OfferAction } from '../../../store/offer.action';
import { OfferState } from '../../../store/offer.state';
import { ScheduleState } from '../../../store/schedule.state';
import { UserState } from '../../../store/user.state';

@Component({
    selector: 'app-offer-card',
    templateUrl: './offer-card.component.html',
    styleUrls: ['./offer-card.component.scss']
})
export class OfferCardComponent implements OnInit, OnDestroy {

    offer: Offer;
    subscriptions: Subscription[] = []
    summaryType = SummaryType;
    user: SystemUser;
    flag: ScheduleFlag;

    get readonly() {
        return this.flag.active === false
            || [EntityRole.WORKER, EntityRole.AGENT, EntityRole.DIRECT_SALES].indexOf(this.user.entityRole) === -1;
    }

    get isActiveSales() {
        return this.flag.active === true
            && [DocumentStatus.IOFFER, DocumentStatus.OFFER].indexOf(this.offer.status.code as DocumentStatus) !== -1
            && [EntityRole.WORKER, EntityRole.AGENT].indexOf(this.user.entityRole) !== -1;
    }

    get canIOffer() {
        const role = this.offer.partyRoleList.find(e => e.role === RoleCode.POLICYHOLDER);
        if (!role) {
            return false;
        }
        const policyholder = this.offer.partyList.find(e => e.id === role.partyId);
        if (!policyholder) {
            return false;
        }
        return this.isActiveSales
            && this.offer.status?.code === DocumentStatus.OFFER
            && !policyholder.foreigner;
    }

    constructor(private store: Store) {
    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.store.select(OfferState.getOffer).subscribe(offer => this.offer = cloneDeep(offer)),
            this.store.select(UserState.getUser).subscribe(user => this.user = user),
            this.store.select(ScheduleState.getFlag).subscribe(flag => this.flag = flag),
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    policy() {
        this.store.dispatch(new OfferAction.Issue(this.offer.id));
    }

    calculation() {
        this.store.dispatch(new OfferAction.BackToCalculation(this.offer.id));
    }

    iOffer() {
        if (this.needsEmailData()) {
            const emailData = new EmailData();
            emailData.email = this.offer.additionalData.contactData.email;
            emailData.clause = !!this.offer.additionalData.clauseMap[ClauseType.CLIENT_CONDITION_1];

            this.store.dispatch(new DialogAction.OpenEmailDialogData(this.offer.id, emailData));
        } else {
            this.store.dispatch(new OfferAction.CreateIOffer(this.offer.id));
        }
    }

    private needsEmailData() {
        return this.offer.additionalData.contactData.email === null
            || !this.offer.additionalData.clauseMap[ClauseType.CLIENT_CONDITION_1];
    }
}
